import { useMutation, useQuery } from '@tanstack/react-query';
import { STATIC } from '../../lib/queryPresets';
import * as svc from '../../services/portal/portalInviteService';

export function useContactPortalAccess(contactId: string | undefined) {
  return useQuery({
    ...STATIC,
    queryKey: ['contact-portal-access', contactId ?? ''],
    queryFn: () => svc.contactHasPortalAccess(contactId!),
    enabled: !!contactId,
  });
}

export function useInviteClient() {
  return useMutation({
    mutationFn: (contactId: string) => svc.inviteClientToPortal(contactId),
  });
}

export function useResendClientInvitation() {
  return useMutation({
    mutationFn: (contactId: string) => svc.resendClientInvitation(contactId),
  });
}
